import { render, staticRenderFns } from "./AppDownloadSection.vue?vue&type=template&id=4394ca00&"
import script from "./AppDownloadSection.vue?vue&type=script&lang=js&"
export * from "./AppDownloadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports